import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { BrowserCookiesModule } from '@ngx-utils/cookies/browser';
import { provideRmaFeatureFlagsBrowser } from '@rma/common-ui-ng/feature-flags';
import { provideRmaInstance } from '@rma/common-ui-ng/instance';
import { agentFinderRoutes } from '@rma/finder/agent-finder';
import { provideRmaTranslation } from '@rma/generic/orc/translation';
import { provideRmaIcon } from '@rma/generic/ui/icon';
import { provideDeviceIdentification } from '@rma/generic/util/device-identification';
import { Environment, provideRmaEnvironment, provideRmaLocale } from '@rma/generic/util/environment';
import { provideRmaJsonHeader } from '@rma/generic/util/http';
import { provideRmaGoogleTracking } from '@rma/generic/util/tracking/analytics';
import { provideRmaHeap } from '@rma/generic/util/tracking/heap';
import { provideRmaTrackJs } from '@rma/generic/util/tracking/track-js';
import { provideUuidGeneration } from '@rma/generic/util/uuid-generation';
import { Angulartics2Module } from 'angulartics2';

declare let window: { rmaConfig: Environment };

export const config = {
  providers: [
    importProvidersFrom(Angulartics2Module.forRoot(), BrowserCookiesModule.forRoot(), BrowserModule),
    Meta,
    provideUuidGeneration(),
    provideDeviceIdentification(),
    provideAnimations(),
    provideRmaEnvironment({ ...window.rmaConfig }),
    provideHttpClient(withInterceptorsFromDi()),
    provideRmaHeap(),
    provideRmaIcon(),
    provideRmaJsonHeader(),
    provideRmaFeatureFlagsBrowser(window.rmaConfig.launchDarklyClientId),
    provideRmaLocale(),
    provideRmaTrackJs(),
    provideRmaTranslation(),
    provideRouter(agentFinderRoutes),
    provideRmaGoogleTracking(),
    provideRmaInstance(window.rmaConfig.tenantCode, window.rmaConfig.type),
  ],
};
